import { faBadgeCheck } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import "./Onboarded.css"

const Onboarded: React.FC<IProps> = ({ name, email }) => {
  const renderTitle = () => (
    <>
      Congratulations <span className="text-gray-900 font-medium">{name}</span>, your account has been created.
    </>
  )

  return (
    <div className="flex items-center justify-center h-full w-full">
      <div className="flex flex-col h-auto w-auto bg-white relative justify-center p-6 md:!p-8 rounded-2xl shadow-[0px_0px_14px_#18300024] gap-y-6 max-w-xl">
        <FontAwesomeIcon icon={faBadgeCheck} className="text-primary !size-14 self-center" />

        <p className="text-base text-gray-500">{renderTitle()}</p>
        {email && (
          <span className="text-base text-gray-500">
            We have sent an email to <span className="text-gray-900 font-medium">{email}</span> with a link to complete
            the registration process.
          </span>
        )}
        {email && <p className="text-base  text-gray-500">Thank you</p>}
      </div>
    </div>
  )
}

type IProps = {
  redirectUrl?: string
  name: string
  email?: string
}

export { Onboarded }
